import * as React from 'react';
import { memo, useMemo } from 'react';
import { FieldRenderProps } from 'react-final-form';
import cn from 'classnames';

import { FieldProps } from '../Field';
import { OptionParameterFragment } from '@websky/graphql';
import { EngineTheme, ThemeProvider, useTheme } from '../../../../theme';

import Autocomplete from '../../../../Autocomplete';
import { useNationality } from './hooks';

interface Props {
	label: string;
	error: string;
	fieldState: FieldRenderProps<string, HTMLInputElement>;
	onBlur?: () => void;
	options: OptionParameterFragment[];
	variant?: 'standard' | 'filled' | 'outlined';
}

const Nationality: React.FC<FieldProps & Props> = memo(
	({ label, field, fieldState, onChange, className, error, onBlur, disabled, variant, options, autofocus }) => {
		const { Input: inputCss } = useTheme('Input');

		const model = useNationality({ options, onChange, field, fieldState });

		const autocompleteTheme = useMemo<EngineTheme>(
			() => ({
				Autocomplete: {
					Autocomplete: {
						option: inputCss.optionLabel,
						disabled: inputCss.disabled,
						inner_input: inputCss.input
					}
				}
			}),
			[]
		);

		return (
			<ThemeProvider value={autocompleteTheme}>
				<Autocomplete
					name={field.name}
					label={label}
					variant={variant}
					autofocus={autofocus}
					callOnSelectOn={'mouseDown'}
					onClickOutsideProps={{
						outsideClickIgnoreClass: 'MuiInputBase-input'
					}}
					inputValue={model.value}
					options={model.options}
					onInputChange={model.onInputChange}
					onSelect={model.onSelect}
					onFocus={model.onFocus}
					onBlur={model.onBlur}
					className={cn(inputCss.nationality, className)}
					error={error}
					disabled={disabled}
				/>
			</ThemeProvider>
		);
	}
);

export default Nationality;
